export default __webpack_public_path__ + "static/media/O_Onibus.c743d7a9.svg";